import Swiper from 'swiper';
import { Pagination, EffectCards } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function(){

    // get swiper element
    const swiperEl = document.querySelector('.cards-swiper');

    if ( !swiperEl ) return;

    // set up swiper
    const swiper = new Swiper(swiperEl, {
        effect: 'cards',
        direction: 'vertical',
        modules: [Pagination, EffectCards],
        cardsEffect: {
            slideShadows: false,
            rotate: false
        },
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });

    const resizeObserver = new ResizeObserver(entries => {
        // when swiper slide image height changes, set the new height to swiper wrapper
        const newHeight = entries[0].contentRect.height;
        swiperEl.style.setProperty('--cards-swiper-height', `${newHeight + 50}px`);
    });

    // start observing swiper-slide image for size changes
    resizeObserver.observe(swiperEl.querySelector('.swiper-slide img'));

});